<div class="registration-container">
  <div class="flexMainallOne">
    <div class="form-section">
      <div class="form-content">
        <h2 class="form-title">Create your School <br />Account with us</h2>

        <form [formGroup]="form" (ngSubmit)="register()" class="registration-form">
          <div class="createAccountSecMain">
            <div class="form-group">
              <input type="text" id="schoolName" formControlName="schoolName" placeholder="School Name*"
                class="form-input" [class.error]="isFieldInvalid('schoolName')" />
              <div class="error-message" *ngIf="isFieldInvalid('schoolName')">
                {{ getFieldError("schoolName") }}
              </div>
            </div>

            <div class="form-group">
              <input type="text" id="adminFirstName" formControlName="adminFirstName" placeholder="Admin First Name*"
                class="form-input" [class.error]="isFieldInvalid('adminFirstName')" />
              <div class="error-message" *ngIf="isFieldInvalid('adminFirstName')">
                {{ getFieldError("adminFirstName") }}
              </div>
            </div>

            <div class="form-group">
              <input type="text" id="adminLastName" formControlName="adminLastName" placeholder="Admin Last Name*"
                class="form-input" [class.error]="isFieldInvalid('adminLastName')" />
              <div class="error-message" *ngIf="isFieldInvalid('adminLastName')">
                {{ getFieldError("adminLastName") }}
              </div>
            </div>

            <div class="form-group">
              <input type="email" id="email" formControlName="email" placeholder="Email*" class="form-input"
                [class.error]="isFieldInvalid('email')" />
              <div class="error-message" *ngIf="isFieldInvalid('email')">
                {{ getFieldError("email") }}
              </div>
            </div>

            <div class="form-group">
              <input type="tel" id="contactNumber" formControlName="contactNumber" placeholder="Contact Number*"
                class="form-input" [class.error]="isFieldInvalid('contactNumber')" />
              <div class="error-message" *ngIf="isFieldInvalid('contactNumber')">
                {{ getFieldError("contactNumber") }}
              </div>
            </div>

            <div class="form-group">
              <textarea id="address" formControlName="address" placeholder="Address*" class="form-input textarea"
                rows="3" [class.error]="isFieldInvalid('address')">
          </textarea>
              <div class="error-message" *ngIf="isFieldInvalid('address')">
                {{ getFieldError("address") }}
              </div>
            </div>

            <div class="form-group">
              <div class="password-wrapper">
                <input [type]="showPasswordVal ? 'text' : 'password'" id="password" formControlName="password"
                  placeholder="Password*" class="form-input" [class.error]="isFieldInvalid('password')" />
                <span class="password-toggle" (click)="showPassword('p')">
                  <i [ngClass]="showPasswordVal? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                </span>
              </div>
              <div class="error-message" *ngIf="isFieldInvalid('password')">
                {{ getFieldError("password") }}
              </div>
            </div>
            <div class="form-group">
              <div class="password-wrapper">
                <input [type]="showConfirmPasswordVal ? 'text' : 'password'" id="confirmPassword"
                  formControlName="confirmPassword" placeholder="Confirm password*" class="form-input" [class.error]="
                isFieldInvalid('confirmPassword') ||
                (form.get('confirmPassword')?.touched && !passwordsMatch())
              " />
                <span class="password-toggle" (click)="showPassword('cp')">
                  <i [ngClass]="showConfirmPasswordVal? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                </span>
              </div>
              <div class="error-message" *ngIf="isFieldInvalid('confirmPassword')">
                {{ getFieldError("confirmPassword") }}
              </div>
              <div class="error-message" *ngIf="form.get('confirmPassword')?.touched && !passwordsMatch()">
                Passwords do not match
              </div>
            </div>
            <!-- License Key -->
            <div class="form-group">
              <input type="text" id="licenseKey" formControlName="licenseKey" placeholder="License Key (16 digits)*"
                class="form-input" maxlength="16" (input)="formatLicenseKey($event)" [class.error]="isFieldInvalid('licenseKey')" />
              <div class="error-message" *ngIf="isFieldInvalid('licenseKey')">
                {{ getFieldError('licenseKey') }}
              </div>
            </div>
            <!-- End -->
          </div>

          <button type="submit" class="register-btn" [disabled]="form.invalid || !passwordsMatch() || isLoading">
            <span *ngIf="!isLoading">Register</span>
            <span *ngIf="isLoading">Registering...</span>
          </button>

        </form>

        <p class="login-link">
          Already have an account? <a routerLink="/login" class="link">Login here</a>
        </p>
      </div>
    </div>

    <div class="info-section">
      <div class="info-content">
        <h2 class="info-title">Why Choose Our School Management Software?</h2>

        <p class="info-description">
          Our software offers comprehensive features to <br />streamline school
          operations and enhance productivity.
        </p>

        <ul class="features-list">
          <li class="feature-item">
            <strong>Efficient Administration:</strong>
            <span>Manage student records, schedules, and attendance with ease.</span>
          </li>
          <li class="feature-item">
            <strong>Communication Tools:</strong>
            <span>Facilitate communication between teachers, students, and
              parents.</span>
          </li>
          <li class="feature-item">
            <strong>Customizable Reports:</strong>
            <span>Generate detailed reports to monitor progress and
              performance.</span>
          </li>
          <li class="feature-item">
            <strong>Secure & Reliable:</strong>
            <span>Ensure data protection with robust security measures.</span>
          </li>
          <li class="feature-item">
            <strong>User-Friendly Interface:</strong>
            <span>Enjoy an intuitive and easy-to-use platform.</span>
          </li>
        </ul>

        <p class="contact-message">
          Contact us to learn more about how our software <br />can benefit your
          school.
        </p>
      </div>
    </div>
  </div>
</div>